import { FC, ReactNode } from 'react';

import { useLocation } from 'react-router';

import { AnalystBanner, Breadcrumbs, PageTitle, TutorialLauncher } from '@/components';
import { DataManagementCrumbs } from '@/constants';
import { APP_ROUTES } from '@/routes';

import styles from './styles.module.scss';

export const MainLayout: FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();
  const isAiresPage = location.pathname.includes(APP_ROUTES.aires);

  return (
    <div className={styles.mainLayout}>
      {isAiresPage && <AnalystBanner />}

      <div className={styles.flex}>
        <div>
          <Breadcrumbs crumbs={DataManagementCrumbs} />
          <PageTitle title="Data Management" />
        </div>

        <TutorialLauncher />
      </div>

      {children}
    </div>
  );
};
